<div class="p-grid">
    <div class="p-col-12">
    <p-toast></p-toast>
    <div class="card">
    <h5>{{ 'sacado.titulo' | translate }}</h5>
    <p-messages [value]="msgs"></p-messages>

            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-4" *ngIf="(perfil != null && (perfil.nmePerfil === 'ADMTIVIT' || perfil.nmePerfil === 'MNGTIVIT' || perfil.nmePerfil === 'OPRTIVIT')) ">
                    <span class="p-float-label" >
                        <h6>{{ 'sacado.cedente' | translate }}</h6>
                        <p-autoComplete [(ngModel)]="cedente" [suggestions]="filteredCedentes"
                                            (completeMethod)="filterCedentes($event)" field="nmeCedente" [dropdown]="true" id="cedente" (click)="cedenteFindByCodigo(cedente)">
                        </p-autoComplete>
                    </span>
                </div>

                <div class="p-field p-col-12 p-md-4" *ngIf="(perfil != null && (perfil.nmePerfil !== 'CONSSACADO')) ">
                    <h6>{{ 'sacado.documento' | translate }}</h6>
                    <input id="documentoSacado" type="text" pInputText  [(ngModel)]="documento" maxlength="16"/>
                </div>

                <div  class="p-field p-col-12 p-md-4" *ngIf="(perfil != null && (perfil.nmePerfil === 'ADMTIVIT' || perfil.nmePerfil === 'MNGTIVIT' || perfil.nmePerfil === 'OPRTIVIT' || perfil.nmePerfil === 'OPRCEDENTE' || perfil.nmePerfil === 'ADMCEDENTE')) && (mostrarPesquisaSacado)" >
                    <span class="p-float-label" >
                        <h6>{{ 'Sacado' | translate }}</h6>
                        <p-autoComplete [(ngModel)]="sacadosCb" [suggestions]="filteredSacados"
                                            (completeMethod)="filterSacados($event)" field="nmeSacado" [dropdown]="true" id="sacadosCb" (click)="sacadoFindBy(sacadosCb)">
                        </p-autoComplete>
                    </span>
                </div>
            </div>

                <button pButton pRipple type="button" label="{{ 'label.pesquisar' | translate }}" (click)="pesquisarSacado()" class="p-mr-2"  *ngIf="(perfil != null && (perfil.nmePerfil !== 'CONSSACADO')) "></button>
                <button pButton pRipple type="button" label="{{ 'label.limparformulario' | translate }}" (click)="limparFormulario()"  class="p-mr-2"  *ngIf="(perfil != null && (perfil.nmePerfil !== 'CONSSACADO')) "></button>
                <!--<button pButton pRipple type="button" label="{{ 'label.exportar' | translate }}" (click)="downloadFile()" *ngIf="sacados != null && sacados.length > 0"></button>-->
                <span *ngIf="sacados != null && sacados.length > 0" class="p-mr-2 p-input-icon-left">
                    <p-splitButton   label="Exportar" icon="pi pi-clone"  [model]="exportOptions" styleClass="p-button-info p-mr-2"></p-splitButton>
                </span>

                <div class="p-col-12" *ngIf="pesquisandoProgress === true">
                    {{ 'label.carregando' | translate }}
                    <p-progressBar mode="indeterminate" [style]="{'height': '30px'}">Carregando...</p-progressBar>
                </div>

                <div class="p-col-12">
                <p-table #dt [value]="sacados" dataKey="codSacado" [columns]="cols" [rows]="10" [paginator]="true"
                                styleClass="p-datatable-customers rowexpand-table"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true"
                                [globalFilterFields]="['codInscricaoSacado','tipoInscricaoSacado.desTipoInscricao','nmeSacado']">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                        <h5 class="p-m-0">{{ 'click.sacados' | translate }}</h5>
                    <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Global Search"/>
                </span>
                </div>
               </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 3rem"></th>
                            <th pSortableColumn="codInscricaoSacado">
                                <div class="p-d-flex p-jc-between p-ai-center">
                                    {{ 'sacado.documento' | translate }}
                                    <p-sortIcon field="codInscricaoSacado"></p-sortIcon>
                                    <p-columnFilter type="text" field="codInscricaoSacado" display="menu" class="p-ml-auto"></p-columnFilter>
                                </div>
                            </th>
                             <th pSortableColumn="tipoInscricaoSacado.desTipoInscricao">
                                <div class="p-d-flex p-jc-between p-ai-center">
                                    {{ 'sacado.tipo' | translate }}
                                    <p-sortIcon field="tipoInscricaoSacado.desTipoInscricao"></p-sortIcon>
                                    <p-columnFilter type="text" field="tipoInscricaoSacado.desTipoInscricao" display="menu" class="p-ml-auto"></p-columnFilter>
                                </div>
                            </th>
                             <th pSortableColumn="nmeSacado">
                                <div class="p-d-flex p-jc-between p-ai-center">
                                    {{ 'sacado.nome' | translate }}
                                    <p-sortIcon field="nmeSacado"></p-sortIcon>
                                    <p-columnFilter type="text" field="nmeSacado" display="menu" class="p-ml-auto"></p-columnFilter>
                                </div>
                            </th>
                            <th pSortableColumn="codUfSacado">
                                <div class="p-d-flex p-jc-between p-ai-center">
                                    {{ 'sacado.uf' | translate }}
                                    <p-sortIcon field="codUfSacado"></p-sortIcon>
                                    <p-columnFilter type="text" field="codUfSacado" display="menu" class="p-ml-auto"></p-columnFilter>
                                </div>
                            </th>
                            <th pSortableColumn="bairroSacado">{{ 'sacado.bairro' | translate }} <p-sortIcon field="bairroSacado"></p-sortIcon></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-sacado let-expanded="expanded">
                        <tr>
                            <td>
                                <button type="button" pButton pRipple [pRowToggler]="sacado" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                            </td>
                            <td>{{sacado.codInscricaoSacado}}</td>
                            <td>{{sacado.tipoInscricaoSacado.desTipoInscricao}}</td>
                            <td>{{sacado.nmeSacado}}</td>
                            <td>{{sacado.codUfSacado}}</td>
                            <td>{{sacado.nmeBairroSacado}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="rowexpansion" let-sacado>
                        <tr>
                            <td colspan="7">
                                <div class="p-p-3">
                                    <p-table [value]="sacado.titulos" dataKey="codTitulo">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th pSortableColumn="bancoResponsavel.nmeBanco">
                                                    <div class="p-d-flex p-jc-between p-ai-center">
                                                        {{ 'sacado.banco' | translate }}
                                                        <p-sortIcon field="bancoResponsavel.nmeBanco"></p-sortIcon>
                                                        <p-columnFilter type="text" field="bancoResponsavel.nmeBanco" display="menu" class="p-ml-auto"></p-columnFilter>
                                                    </div>
                                                </th>
                                                <th pSortableColumn="codNossoNumero">
                                                    <div class="p-d-flex p-jc-between p-ai-center">
                                                        {{ 'sacado.nossonumero' | translate }}
                                                        <p-sortIcon field="codNossoNumero"></p-sortIcon>
                                                        <p-columnFilter type="numeric" field="codNossoNumero" display="menu" class="p-ml-auto"></p-columnFilter>
                                                    </div>
                                                </th>
                                                <th pSortableColumn="dtaVencimento">
                                                    <div class="p-d-flex p-jc-between p-ai-center">
                                                        {{ 'sacado.datavencimento' | translate }}
                                                        <p-sortIcon field="dtaVencimento"></p-sortIcon>
                                                        <p-columnFilter type="date" field="dtaVencimento" display="menu" class="p-ml-auto"></p-columnFilter>
                                                    </div>
                                                </th>
                                                <th pSortableColumn="vlrTitulo">
                                                    <div class="p-d-flex p-jc-between p-ai-center">
                                                       {{ 'sacado.valor' | translate }}
                                                        <p-sortIcon field="vlrTitulo"></p-sortIcon>
                                                        <p-columnFilter type="numeric" field="vlrTitulo" display="menu" class="p-ml-auto"></p-columnFilter>
                                                    </div>
                                                </th>
                                                <th pSortableColumn="statusBoleto.desStatusBoleto">
                                                    <div class="p-d-flex p-jc-between p-ai-center">
                                                       {{ 'label.status' | translate }}
                                                        <p-sortIcon field="statusBoleto.desStatusBoleto"></p-sortIcon>
                                                        <p-columnFilter type="text" field="statusBoleto.desStatusBoleto" display="menu" class="p-ml-auto"></p-columnFilter>
                                                    </div>
                                                </th>
                                                <th style="width: 16rem"></th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-titulo>
                                            <tr>
                                                <td>{{titulo.bancoResponsavel.nmeBanco}}</td>
                                                <td>{{titulo.codNossoNumero}}</td>
                                                <td>{{titulo.dtaVencimento | date: 'dd/MM/yyyy'}}</td>
                                                <td>{{titulo.vlrTitulo | currency:'BRL'}}</td>
                                                <td *ngIf="(titulo.statusBoleto)"><span [class]="'titulo-badge titulo-status-' + titulo.statusBoleto.desStatusBoletoTrimmed.toLowerCase()">{{titulo.statusBoleto.desStatusBoleto}}</span></td>
                                                <td *ngIf="(!titulo.statusBoleto)"></td>
                                                <td>
                                                <p-button type="button" icon="pi pi-search" class="p-button-rounded p-button-success p-mr-2" (click)="viewBoleto(titulo, sacado)" alt="Visualizar Boleto"
                                                    *ngIf="titulo.statusBoleto.desStatusBoleto === 'Registrado' || titulo.statusBoleto.desStatusBoleto === 'Liquidado'"></p-button>
                                                <button pButton pRipple icon="pi pi-envelope" class="p-button-rounded p-button-success p-mr-2" (click)="sendEditBanco(titulo, sacado)"
                                                    *ngIf="titulo.statusBoleto.desStatusBoleto === 'Registrado'" alt="Enviar 2 via"></button>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="6">Não existe boleto para o sacado.</td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                                <div class="p-d-flex p-ai-center p-jc-between">
                                     {{ 'label.totalde' | translate }}   {{sacados ? sacados.length : 0 }} {{ 'sacado.sacados' | translate }}.
                                </div>
                            </ng-template>
                </p-table>
                </div>

          <p-dialog id="sacadoDialogPrint" [(visible)]="sacadoDialog" height="auto" header="{{ 'sacado.detalhes' | translate }}" [modal]="true" styleClass="p-fluid">
            <ng-template pTemplate="content">
                <div class="p-field">
                   <img  [src]="url"/>
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <button pButton pRipple label="{{ 'label.cancelar' | translate }}" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
                <button pButton pRipple label="{{ 'label.download' | translate }}" icon="pi pi-times" class="p-button-text" (click)="downloadPdf()"></button>
            </ng-template>
        </p-dialog>

        <div class="p-col-12">
            <p-dialog [(visible)]="tituloDialog" [style]="{width: '450px'}" header="{{ 'titulo.segundavia' | translate }}" [modal]="true" styleClass="p-fluid">
                <ng-template pTemplate="content">
                    <div class="p-field">
                        <label for="name">{{ 'titulo.nomesacado' | translate }}</label>
                        <input type="text" pInputText id="nmeSacado" [(ngModel)]="sacadoEmail.nmeSacado" readonly />
                    </div>
                    <div class="p-field">
                        <label for="name">{{ 'titulo.email' | translate }}</label>
                        <input type="text" pInputText id="emailSacado" [(ngModel)]="emailSacado.nmeEmail" required autofocus />
                        <small class="p-invalid" *ngIf="submitted && !emailSacado.nmeEmail">E-mail do banco � obrigat�rio.</small>
                    </div>
                </ng-template>
                <ng-template pTemplate="footer">
                    <button pButton pRipple label="{{ 'label.cancelar' | translate }}" icon="pi pi-times" class="p-button-text" (click)="hideDialogTitulo()"></button>
                    <button pButton pRipple label="{{ 'label.enviaremail' | translate }}" icon="pi pi-check" class="p-button-text" (click)="sendEmail(titulo)"></button>
                </ng-template>
            </p-dialog>

        </div>
